'use strict';
const _ = require('underscore');
module.exports = function exportTableToText(table) {
	return _.map(table, function (row) {
		return _.map(row, function (cell) {
			if (!cell) {
				return '';
			}
			return cell.toString().replace(/\t|\n|\r/g, ' ');
		}).join('\t');
	}).join('\n');
};
